module.exports = __webpack_public_path__ + "static/media/dungeoncrawler.5752fca3.mp4";